import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { DataService } from '@ideenherd/core/data';
import DevExpress from 'devextreme';
import { ToastComponent } from 'libs/ideenherd-library/src/lib/toast/toast.component';
import { first } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SINECTROUTES } from './app-routing.module';
import { AppService } from './app.service';

@Component({
  selector: 'ideenherd-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild('toast', { static: false }) toast: ToastComponent;

  public logo: SafeResourceUrl;

  public contextMenuPosition: DevExpress.PositionConfig = { at: 'right top', my: 'right bottom' };
  public contextMenuItems = [
    {
      text: 'Logout',
      icon: 'assets/images/exit-event.svg',
      onClick: () => {
        localStorage.removeItem('eventCode');
        this.appService.clearData();
        this.router.navigate([this.dataService.tenant]);
      },
    },
  ];

  constructor(
    public appService: AppService,
    private domSanitizer: DomSanitizer,
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  public ngOnInit(): void {
    // enable customer selection on event verifier component
    this.route.queryParams.subscribe((params: Params) => {
      if (params['a'] !== undefined) {
        localStorage.setItem('showCustomers', '1');
        this.router.navigate([], { relativeTo: this.route, queryParams: null });
      }
    })

    this.redirectWhenReload();

    this.appService.accreditationConfigLoaded.pipe(first()).subscribe(() => {
      this.logo = this.appService.accreditationConfig.logo
        ? this.domSanitizer.bypassSecurityTrustResourceUrl(`data:image/svg+xml;base64,${this.appService.accreditationConfig.logo}`)
        : null;
    });

    this.appService.notification$.subscribe((notification) => {
      this.toast.showNotification(notification);
    })
  }

  public redirectWhenReload(): void {
    this.router.events
      .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
      .subscribe((event) => {
        if (event.id === 1 && event.url === event.urlAfterRedirects) {
          this.appService.clearData();
          this.dataService.tenant = localStorage.getItem('tenant');
          this.router.navigate([this.dataService.tenant], { queryParamsHandling: 'preserve' });
        }
      });
  }

  public returnButton(): void {
    this.appService.callBackButton();
  }

  public goToHome(): void {
    this.router.navigateByUrl(SINECTROUTES.EVENT_DETAIL);
  }

  public goToScanner(): void {
    if (!this.appService.participantList[this.appService.eventDetails?.[0]?.id]) {
      return;
    }

    this.router.navigate([
      SINECTROUTES.EVENT_SCANNER.replace(':path', SINECTROUTES.EVENT_DETAIL_PARTICIPANT)
    ]);
  }
}
